import './../App.css';
import React, {Component} from 'react';
import MemberCard from './../components/MemberCard';
import html2canvas from 'html2canvas';
import { GlobalSiteContext } from '../context/GlobalSiteContext';

class Index extends Component 
{
	static contextType = GlobalSiteContext
	constructor() {
		super();
		this.state = {showAdvancedStat: false};
		this.toogleShowAdvancedStat = this.toogleShowAdvancedStat.bind(this);
	}
	takeScreen(){
		html2canvas(document.getElementById("box_AEG Shaunz"), {
			allowTaint: true
		}).then(function(canvas) {
			var anchorTag = document.createElement("a");
			document.body.appendChild(anchorTag);
			anchorTag.download = "Picture.png";
			anchorTag.href = canvas.toDataURL();
			anchorTag.target = '_blank';
			anchorTag.click();
		});
	}
	
	toogleShowAdvancedStat(){
		this.setState(prevState => ({
			showAdvancedStat: !prevState.showAdvancedStat
		  }));
	}
	render() {
		const {members} = this.context;
		if(members != null){
			
			return ( 
                <div className="w-full grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-8 gap-y-12 px-8 mb-20">
                    {members.map((member) => (
                        <MemberCard showAdvancedStat={this.state.showAdvancedStat} key={member.id} name={member.name} summonerId={member.id} puuid={member.puuid} />
                    ))}
                </div>
			)
		} else {
			return (
                <div className="flex justify-center items-center w-100">
                    <div className="w-16 h-16 border-b-2 border-white-900 rounded-full animate-spin"></div>
                </div>
        
			)
		}
	};
}
export default Index;